import { render, staticRenderFns } from "./LoginBseller.vue?vue&type=template&id=f320043a&scoped=true&"
import script from "./LoginBseller.vue?vue&type=script&lang=js&"
export * from "./LoginBseller.vue?vue&type=script&lang=js&"
import style0 from "./LoginBseller.vue?vue&type=style&index=0&id=f320043a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f320043a",
  null
  
)

export default component.exports